// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__3+Maa","Menu-triangle":"Menu_Menu-triangle__QzVe9","Menu-display":"Menu_Menu-display__H7P3f","show":"Menu_show__Bnals"};